import { Flex, Skeleton } from '@zoomit/primitives';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

const NotificationSkeleton = () => {
  return (
    <Flex flexDirection="column" data-testid="notification-skeleton">
      <Flex spacing={{ py: 'x4' }} flexDirection="column" gap={2}>
        <Flex justifyContent="space-between">
          <Flex gap={0.6} alignItems="center">
            <Skeleton width={1.6} height={1.6} />
            <Typography variant="subhead" textColor={cssVar(theme.grey1)}>
              <Skeleton width={6} height={1.6} />
            </Typography>
          </Flex>
        </Flex>
        <Flex gap={1.4}>
          <Skeleton height={2} />
          <Skeleton height={2} />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default NotificationSkeleton;
